module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/diana-358485f63b6c6d02597b945cb33bc821.jpg";